<template>
  <div>
    <NuxtLink v-if="withAuthorLink" :style="{ textDecoration: 'none' }" :to="profileUrl">{{ author }}</NuxtLink>
    <template v-else>{{ author }}</template>
    <span :style="{ color: secondaryColor }">closed</span>
    <template v-if="company">{{ company }}</template>
    <span v-else :style="{ color: secondaryColor }">a deal</span>
    <span :style="{ color: secondaryColor }">for</span>
    ${{ amountAbbreviated }}
    <template v-if="departments.length">
      <span :style="{ color: secondaryColor }">to the</span>
      {{ departments.join(', ') }}
      <span :style="{ color: secondaryColor }">{{ departments.length | pluralize('department') }}</span>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { abbreviateNumber } from '@/components/utils/core/number';

export default Vue.extend({
  name: 'WarRoomDealStoryHeaderFormatter',
  props: {
    author: {
      type: String,
      required: true,
    },
    withAuthorLink: {
      type: Boolean,
      default: true,
    },
    company: {
      type: String,
      default: '',
    },
    amount: {
      type: [Number, String],
      required: true,
    },
    departments: {
      type: Array,
      default: () => [],
    },
    secondaryColor: {
      type: String,
      default: '#797B86',
    },
  },
  computed: {
    amountAbbreviated(): string {
      return abbreviateNumber(Number(this.amount));
    },
    profileUrl(): string {
      return `/war-room/profile/${this.author}`;
    },
  },
});
</script>
